const uk = {
  // ============================================================
  // COMMON — Спільне для всього застосунку
  // ============================================================
  common: {
    loading: 'Завантаження...',
    error: 'Помилка',
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    edit: 'Редагувати',
    create: 'Створити',
    add: 'Додати',
    remove: 'Вилучити',
    close: 'Закрити',
    confirm: 'Підтвердити',
    apply: 'Застосувати',
    reset: 'Скинути',
    search: 'Пошук',
    filter: 'Фільтр',
    clear: 'Очистити',
    back: 'Назад',
    next: 'Далі',
    previous: 'Попередній',
    submit: 'Надіслати',
    update: 'Оновити',
    refresh: 'Оновити',
    export: 'Експорт',
    import: 'Імпорт',
    download: 'Завантажити',
    upload: 'Вивантажити',
    print: 'Друк',
    copy: 'Копіювати',
    yes: 'Так',
    no: 'Ні',
    ok: 'OK',
    done: 'Готово',
    select: 'Обрати',
    selectAll: 'Обрати все',
    deselectAll: 'Зняти вибір',
    noResults: 'Результатів не знайдено',
    noData: 'Дані відсутні',
    required: 'Обов\'язкове',
    optional: 'Необов\'язкове',
    actions: 'Дії',
    details: 'Деталі',
    overview: 'Огляд',
    summary: 'Підсумок',
    total: 'Усього',
    all: 'Усі',
    none: 'Жодного',
    name: 'Назва',
    type: 'Тип',
    status: 'Статус',
    date: 'Дата',
    time: 'Час',
    description: 'Опис',
    notes: 'Примітки',
    comments: 'Коментарі',
    category: 'Категорія',
    priority: 'Пріоритет',
    nation: 'Країна',
    country: 'Країна',
    email: 'Електронна пошта',
    phone: 'Телефон',
    address: 'Адреса',
    location: 'Місцезнаходження',
    coordinates: 'Координати',
    latitude: 'Широта',
    longitude: 'Довгота',
    from: 'Від',
    to: 'До',
    createdAt: 'Створено',
    updatedAt: 'Оновлено',
    createdBy: 'Створив(-ла)',
    modifiedBy: 'Змінив(-ла)',
    active: 'Активний',
    inactive: 'Неактивний',
    enabled: 'Увімкнено',
    disabled: 'Вимкнено',
    showing: 'Показано',
    of: 'з',
    page: 'Сторінка',
    perPage: 'на сторінку',
    rows: 'рядків',
    items: 'елементів',
    results: 'результатів',
    sortBy: 'Сортувати за',
    ascending: 'За зростанням',
    descending: 'За спаданням',
    viewAll: 'Переглянути все',
    viewDetails: 'Переглянути деталі',
    goBack: 'Повернутися',
    learnMore: 'Дізнатися більше',
    seeMore: 'Показати більше',
    showMore: 'Показати більше',
    showLess: 'Показати менше',
    expandAll: 'Розгорнути все',
    collapseAll: 'Згорнути все',
    copied: 'Скопійовано!',
    saved: 'Збережено!',
    deleted: 'Видалено!',
    updated: 'Оновлено!',
    created: 'Створено!',
    success: 'Успіх',
    warning: 'Попередження',
    info: 'Інформація',
    danger: 'Небезпека',
    unknown: 'Невідомо',
    notAvailable: 'Н/Д',
    never: 'Ніколи',
    today: 'Сьогодні',
    yesterday: 'Вчора',
    tomorrow: 'Завтра',
    now: 'Зараз',
    ago: 'тому',
    justNow: 'щойно',
    minutesAgo: '{{count}} хв тому',
    hoursAgo: '{{count}} год тому',
    daysAgo: '{{count}} дн тому',
    monthsAgo: '{{count}} міс тому',
    id: 'ID',
    version: 'Версія',
    language: 'Мова',
    theme: 'Тема',
    darkMode: 'Темна тема',
    lightMode: 'Світла тема',
    failedToLoad: 'Не вдалося завантажити дані',
    failedToSave: 'Не вдалося зберегти',
    failedToDelete: 'Не вдалося видалити',
    failedToUpdate: 'Не вдалося оновити',
    confirmDelete: 'Ви впевнені, що хочете це видалити?',
    confirmAction: 'Ви впевнені?',
    unsavedChanges: 'У вас є незбережені зміни. Ви впевнені, що хочете вийти?',
    pageNotFound: '404 — Сторінку не знайдено',
    pageNotFoundDesc: 'Сторінка, яку ви шукаєте, не існує.',
    backToDashboard: 'Повернутися на головну панель',
    characters: 'символів',
    maxCharacters: 'Максимум {{max}} символів',
    remaining: 'Залишилося {{count}}',
    selected: 'Обрано {{count}}',
    of_total: '{{count}} з {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Заголовок, бічна панель, меню
  // ============================================================
  nav: {
    dashboard: 'Головна панель',
    requests: 'Запити',
    transports: 'Транспортування',
    myPatients: 'Мої пацієнти',
    statistics: 'Статистика',
    flow: 'Потік',
    resources: 'Resources',
    exercise: 'Навчання',
    administration: 'Адміністрування',
    map: 'Карта',
    info: 'Інформація',
    users: 'Користувачі',
    assets: 'Засоби',
    hubs: 'Вузли',
    treatmentFacilities: 'Лікувальні заклади',
    patientImport: 'Імпорт пацієнтів',
    assetTemplates: 'Шаблони засобів',
    dayTemplates: 'Шаблони днів',
    announcementTicker: 'Стрічка оголошень',
    exerciseStatistics: 'Статистика навчань',
    settings: 'Налаштування',
    auditLog: 'Журнал аудиту',
    exerciseControl: 'Керування навчанням',
    dataSync: 'Синхронізація даних',
    documentation: 'Документація',
    support: 'Підтримка',
    about: 'Про систему',
    assetContracts: 'Asset Contracts',
    notifications: 'Сповіщення',
    schedules: 'Розклади',
    capacityPlanning: 'Планування потужностей',
    transportPlanning: 'Планування транспортування',
    transportBooking: 'Бронювання транспорту',
    flowDiagram: 'Діаграма потоків',
    changePassword: 'Змінити пароль',
    missions: 'Місії',
    startPoints: 'Початкові точки',
    hospital: 'Лікарня',
  },

  // ============================================================
  // AUTH — Вхід, пароль, сеанс
  // ============================================================
  auth: {
    login: 'Увійти',
    logout: 'Вийти',
    logoutNow: 'Вийти зараз',
    loggingIn: 'Вхід...',
    loginFailed: 'Не вдалося увійти',
    email: 'Електронна пошта',
    password: 'Пароль',
    username: 'Ім\'я користувача',
    enterEmail: 'Введіть вашу електронну адресу',
    enterPassword: 'Введіть ваш пароль',
    enterUsername: 'Введіть ваше ім\'я користувача',
    forgotPassword: 'Забули пароль?',
    forgotPasswordTitle: 'Забутий пароль',
    forgotPasswordDesc: 'Введіть ваше ім\'я користувача та електронну адресу. Якщо обидва збігаються, адміністратори будуть повідомлені для скидання вашого пароля.',
    requestPasswordReset: 'Запит на скидання пароля',
    sending: 'Надсилання...',
    backToLogin: 'Повернутися до входу',
    pleaseWait: 'Будь ласка, зачекайте перед повторною спробою.',
    requestFailed: 'Запит не вдався',
    credentialsMatch: 'Якщо облікові дані збігаються, адміністратори повідомлені.',
    forAccess: 'Для отримання доступу зверніться до системного адміністратора.',
    changePassword: 'Змінити пароль',
    currentPassword: 'Поточний пароль',
    newPassword: 'Новий пароль',
    confirmPassword: 'Підтвердження пароля',
    passwordChanged: 'Пароль успішно змінено',
    passwordMismatch: 'Паролі не збігаються',
    passwordTooShort: 'Пароль має містити щонайменше 8 символів',
    changingPassword: 'Зміна...',
    mustChangePassword: 'Ви повинні змінити пароль перед продовженням.',
    sessionExpiring: 'Сеанс закінчується',
    sessionExpireText: 'Ваш сеанс закінчиться через <strong>{{time}}</strong>. Будь ласка, збережіть роботу та увійдіть знову, щоб продовжити.',
    dismiss: 'Закрити',
    switchNation: 'Змінити країну',
    returnTo: 'Повернутися до {{nation}}',
    viewingAs: 'Ви переглядаєте як',
    loggedInAs: 'увійшли як {{nation}}',
    trainingMode: 'ЛИШЕ ДЛЯ НАВЧАЛЬНИХ ЦІЛЕЙ',
    dedication: 'Створено з любов\'ю та відданістю професії',
  },

  // ============================================================
  // ROLES — Ролі користувачів та позначки
  // ============================================================
  roles: {
    admin: 'Системний адміністратор',
    excon: 'Керівник навчання',
    eu: 'Координатор ЄС',
    planner: 'Планувальник',
    hub: 'Менеджер вузла',
    nation: 'Країна',
    readOnly: 'Лише читання',
    systemAdmin: 'Системний адміністратор',
    transportPlanner: 'Планувальник транспортування',
    systemRoles: 'Системні ролі',
  },

  // ============================================================
  // STATUS — Статуси запитів, пропозицій, місій
  // ============================================================
  status: {
    draft: 'Чернетка',
    underReview: 'На розгляді',
    published: 'Опубліковано',
    underSelection: 'На відборі',
    accepted: 'Прийнято',
    planned: 'Заплановано',
    inTransit: 'У дорозі',
    completed: 'Завершено',
    closed: 'Закрито',
    withdrawn: 'Відкликано',
    pending: 'Очікує',
    rejected: 'Відхилено',
    cancelled: 'Скасовано',
    active: 'Активний',
    inactive: 'Неактивний',
    review: 'Розгляд',
    selection: 'Відбір',
    transit: 'Транзит',
  },

  // ============================================================
  // CATEGORIES — Категорії запитів
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Персонал',
    material: 'Матеріали',
    equipment: 'Обладнання',
    other: 'Інше',
    news: 'Новини',
  },

  // ============================================================
  // URGENCY — Рівні терміновості
  // ============================================================
  urgency: {
    routine: 'Плановий',
    priority: 'Пріоритетний',
    urgent: 'Терміновий',
    immediate: 'Негайний',
  },

  // ============================================================
  // ASSETS — Типи транспортних засобів
  // ============================================================
  assetTypes: {
    train: 'Потяг',
    ship: 'Судно',
    aircraft: 'Літак',
    bus: 'Автобус',
    ambulance: 'Швидка допомога',
    drone: 'Безпілотник',
    helicopter: 'Гелікоптер',
    ferry: 'Пором',
    other: 'Інше',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Головна панель',
    goodMorning: 'Доброго ранку',
    goodAfternoon: 'Доброго дня',
    goodEvening: 'Доброго вечора',
    lastLogin: 'Останній вхід',
    infrastructure: 'Інфраструктура',
    transportAssets: 'Транспортні засоби',
    treatmentFacilities: 'Лікувальні заклади',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Статистика запитів',
    viewAllRequests: 'Переглянути всі запити',
    availableAssets: 'Доступні засоби',
    seated: 'Сидячі',
    lying: 'Лежачі',
    intensive: 'Інтенсивна терапія',
    notifications: 'Сповіщення',
    markAllRead: 'Позначити всі прочитаними',
    noNotifications: 'Сповіщень ще немає',
    notifiedWhenActivity: 'Ви отримаєте сповіщення, коли з\'явиться нова активність',
    viewDetailsBtn: 'Переглянути деталі',
    nationUsers: 'Користувачі країни',
    user: 'Користувач',
    roles: 'Ролі',
    noUsersFound: 'Користувачів не знайдено',
    participatingNations: 'Країни-учасниці',
    exerciseDisclaimer: 'Ця система призначена лише для навчальних цілей. Вводьте виключно змодельовані навчальні дані. Робочі процеси адаптовані до навчального сценарію та можуть відрізнятися від реальних процедур. Правила ІТ-безпеки та захисту даних залишаються повністю чинними.',
    notConfigured: 'Не налаштовано',
    requestCount: '{{count}} запит(ів)',
    clickToView: 'Натисніть для перегляду',
    systemAdministration: 'Системне адміністрування',
    exerciseControlTitle: 'Керування навчанням',
    euCoordination: 'Координація ЄС',
    transportPlanningTitle: 'Планування транспортування',
    hubManagement: 'Управління вузлами',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Новий запит',
    myDrafts: 'Мої чернетки',
    pendingReview: 'На розгляді',
    activeTransports: 'Активні транспортування',
    myPatients: 'Мої пацієнти',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Запити',
    newRequest: 'Новий запит',
    createRequest: 'Створити запит',
    editRequest: 'Редагувати запит',
    requestDetail: 'Деталі запиту',
    requestId: 'ID запиту',
    fromNation: 'Від країни',
    toNation: 'До країни',
    requestingNation: 'Країна-заявник',
    receivingNation: 'Країна-отримувач',
    category: 'Категорія',
    urgency: 'Терміновість',
    status: 'Статус',
    patients: 'Пацієнти',
    patientCount: 'Кількість пацієнтів',
    offers: 'Пропозиції',
    offerCount: 'Кількість пропозицій',
    created: 'Створено',
    updated: 'Оновлено',
    submittedBy: 'Подав(-ла)',
    reviewedBy: 'Розглянув(-ла)',
    description: 'Опис',
    medicalDetails: 'Медичні деталі',
    transportDetails: 'Деталі транспортування',
    additionalInfo: 'Додаткова інформація',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Пункт відправлення',
    arrivalPoint: 'Пункт прибуття',
    estimatedDeparture: 'Орієнтовне відправлення',
    estimatedArrival: 'Орієнтовне прибуття',
    submitForReview: 'Надіслати на розгляд',
    publish: 'Опублікувати',
    startSelection: 'Розпочати відбір',
    acceptOffer: 'Прийняти пропозицію',
    markInTransit: 'Позначити як у дорозі',
    markCompleted: 'Позначити як завершене',
    closeRequest: 'Закрити запит',
    withdrawRequest: 'Відкликати запит',
    withdraw: 'Відкликати',
    revertToDraft: 'Повернути до чернетки',
    deleteRequest: 'Видалити запит',
    duplicateRequest: 'Дублювати запит',
    createFollowUp: 'Створити консолідований запит',
    followUpRequest: 'Консолідований запит',
    parentRequest: 'Початковий запит',
    childRequests: 'Консолідовані запити',
    noRequests: 'Запитів не знайдено',
    noOffers: 'Пропозицій ще немає',
    addPatient: 'Додати пацієнта',
    removePatient: 'Вилучити пацієнта',
    patientDetails: 'Деталі пацієнта',
    contactPerson: 'Контактна особа',
    contactPhone: 'Контактний телефон',
    contactEmail: 'Контактна електронна пошта',
    specialRequirements: 'Спеціальні вимоги',
    medicalEquipment: 'Медичне обладнання',
    accompaniment: 'Супровід',
    timeline: 'Хронологія',
    history: 'Історія',
    addComment: 'Додати коментар',
    writeComment: 'Напишіть коментар...',
    postComment: 'Опублікувати коментар',
    posting: 'Публікація...',
    noComments: 'Коментарів ще немає',
    coverageBar: 'Покриття',
    covered: 'покрито',
    uncovered: 'не покрито',
    filterByStatus: 'Фільтрувати за статусом',
    filterByCategory: 'Фільтрувати за категорією',
    filterByNation: 'Фільтрувати за країною',
    searchRequests: 'Пошук запитів...',
    confirmWithdraw: 'Ви впевнені, що хочете відкликати цей запит?',
    confirmDelete: 'Ви впевнені, що хочете видалити цей запит?',
    confirmPublish: 'Ви впевнені, що хочете опублікувати цей запит? Він стане видимим для всіх країн.',
    confirmStartSelection: 'Ви впевнені, що хочете розпочати відбір? Країни зможуть надавати пропозиції.',
    warningStartSelection: 'Початок відбору зробить цей запит видимим для всіх країн-учасниць. Вони зможуть подавати пропозиції щодо пацієнтів у цьому запиті. Цю дію неможливо скасувати.',
    warningMakeOffer: 'Надсилаючи цю пропозицію, ви зобов\'язуєте свою країну надати запропоновану допомогу. Ця дія повідомить країну-заявника та керівництво навчання.',
    saveDraft: 'Зберегти чернетку',
    saving: 'Збереження...',
    saveAndSubmit: 'Зберегти та надіслати',
    step: 'Крок {{number}}',
    generalInfo: 'Загальна інформація',
    patientInfo: 'Інформація про пацієнтів',
    logisticsInfo: 'Логістична інформація',
    reviewSubmit: 'Перегляд та надсилання',
    requestTitle: 'Назва запиту',
    requestDescription: 'Опис запиту',
    numberOfPatients: 'Кількість пацієнтів',
    typeOfAssistance: 'Тип допомоги',
    medicalTreatment: 'Медичне лікування',
    transportAssistance: 'Транспортна допомога',
    both: 'Обидва',
    treatmentOnly: 'Лише лікування',
    transportOnly: 'Лише транспортування',
    validationErrors: 'Будь ласка, виправте наступні помилки:',
    fieldRequired: 'Це поле є обов\'язковим',
    selectExitHub: 'Оберіть вихідний вузол',
    createExitHub: 'Створити вихідний вузол',
    backToRequests: 'Повернутися до запитів',
    noRequestsFound: 'Запитів не знайдено',
    createFirstRequest: 'Створіть свій перший запит, щоб розпочати',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Пропозиції',
    createOffer: 'Створити пропозицію',
    makeOffer: 'Зробити пропозицію',
    manageOffers: 'Управління пропозиціями',
    offerDetail: 'Деталі пропозиції',
    offerId: 'ID пропозиції',
    offeringNation: 'Країна-пропонент',
    offerType: 'Тип пропозиції',
    treatment: 'Лікування',
    transport: 'Транспортування',
    combined: 'Комбінована',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Пропозиція лікування',
    transportOffer: 'Пропозиція транспортування',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Обрати пацієнтів',
    selectedPatients: 'Обрані пацієнти',
    patientSelection: 'Вибір пацієнтів',
    offerConfiguration: 'Конфігурація пропозиції',
    reviewOffer: 'Перегляд пропозиції',
    submitOffer: 'Надіслати пропозицію',
    submitting: 'Надсилання...',
    acceptOffer: 'Прийняти пропозицію',
    rejectOffer: 'Відхилити пропозицію',
    withdrawOffer: 'Відкликати пропозицію',
    noOffers: 'Пропозицій немає',
    noOffer: 'No Offer',
    offerStatus: 'Статус пропозиції',
    offerDate: 'Дата пропозиції',
    transportAsset: 'Транспортний засіб',
    departureDate: 'Дата відправлення',
    arrivalDate: 'Дата прибуття',
    treatmentFacility: 'Лікувальний заклад',
    capacity: 'Місткість',
    availableCapacity: 'Доступна місткість',
    totalCapacity: 'Загальна місткість',
    selectAsset: 'Обрати засіб',
    selectFacility: 'Обрати заклад',
    offerNotes: 'Примітки до пропозиції',
    confirmAccept: 'Ви впевнені, що хочете прийняти цю пропозицію?',
    confirmReject: 'Ви впевнені, що хочете відхилити цю пропозицію?',
    extendTransport: 'Продовжити транспортування',
    transportExtension: 'Продовження транспортування',
    comparisonView: 'Порівняльний перегляд',
    shortlist: 'Попередній відбір',
    addToShortlist: 'Додати до попереднього відбору',
    removeFromShortlist: 'Вилучити з попереднього відбору',
    leaveConfirmTitle: 'Покинути цю сторінку?',
    leaveConfirmMessage: 'У вас є незбережені зміни. Ви впевнені, що хочете вийти?',
    stayOnPage: 'Залишитися на сторінці',
    leavePage: 'Покинути сторінку',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Транспортування',
    missionDetail: 'Деталі транспортування',
    missionId: 'ID транспортування',
    missionStatus: 'Статус транспортування',
    createMission: 'Створити транспортування',
    overview: 'Огляд',
    patientsTab: 'Пацієнти',
    transportsTab: 'Етапи транспортування',
    treatmentTab: 'Лікування',
    reviewTab: 'Перегляд',
    departure: 'Відправлення',
    arrival: 'Прибуття',
    origin: 'Місце відправлення',
    destination: 'Місце призначення',
    stops: 'Зупинки',
    addStop: 'Додати зупинку',
    removeStop: 'Вилучити зупинку',
    stopName: 'Назва зупинки',
    stopType: 'Тип зупинки',
    estimatedTime: 'Орієнтовний час',
    actualTime: 'Фактичний час',
    asset: 'Засіб',
    driver: 'Водій',
    crew: 'Екіпаж',
    noMissions: 'Транспортувань не знайдено',
    completeMission: 'Завершити транспортування',
    cancelMission: 'Скасувати транспортування',
    startTransport: 'Розпочати транспортування',
    missionChain: 'Ланцюг транспортування',
    linkedMissions: 'Пов\'язані транспортування',
    handover: 'Передача',
    handoverPoint: 'Пункт передачі',
    pickupPoint: 'Пункт посадки',
    dropoffPoint: 'Пункт висадки',
    searchTransports: 'Пошук транспортувань...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Пацієнти',
    myPatients: 'Мої пацієнти',
    patientId: 'ID пацієнта',
    firstName: 'Ім\'я',
    lastName: 'Прізвище',
    dateOfBirth: 'Дата народження',
    age: 'Вік',
    gender: 'Стать',
    male: 'Чоловіча',
    female: 'Жіноча',
    other: 'Інша',
    nationality: 'Громадянство',
    diagnosis: 'Діагноз',
    condition: 'Стан',
    stable: 'Стабільний',
    critical: 'Критичний',
    serious: 'Серйозний',
    treatmentNeeded: 'Необхідне лікування',
    allergies: 'Алергії',
    medications: 'Медикаменти',
    bloodType: 'Група крові',
    weight: 'Вага (кг)',
    infectious: 'Інфекційний',
    mentalHealth: 'Психічне здоров\'я',
    mobility: 'Мобільність',
    ambulatory: 'Амбулаторний',
    wheelchair: 'Інвалідний візок',
    stretcher: 'Ноші',
    intensive: 'Інтенсивна терапія',
    oxygenRequired: 'Потрібен кисень',
    ventilator: 'Апарат ШВЛ',
    medicalEscort: 'Медичний супровід',
    noPatients: 'Пацієнтів не знайдено',
    patientDetails: 'Деталі пацієнта',
    medicalHistory: 'Медична історія',
    travelDocuments: 'Дорожні документи',
    passport: 'Паспорт',
    pseudonymizedId: 'Псевдонімізований ID',
    sensitiveData: 'Конфіденційні дані',
    journey: 'Маршрут пацієнта',
    assignedTo: 'Призначено до',
    currentLocation: 'Поточне місцезнаходження',
    importPatients: 'Імпорт пацієнтів',
    exportPatients: 'Експорт пацієнтів',
    seated: 'Сидячий',
    lying: 'Лежачий',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Користувачі',
    createUser: 'Створити користувача',
    editUser: 'Редагувати користувача',
    deleteUser: 'Видалити користувача',
    username: 'Ім\'я користувача',
    displayName: 'Відображуване ім\'я',
    email: 'Електронна пошта',
    password: 'Пароль',
    role: 'Роль',
    roles: 'Ролі',
    nation: 'Країна',
    active: 'Активний',
    lastLogin: 'Останній вхід',
    createdAt: 'Створено',
    isNation: 'Країна',
    isEU: 'ЄС',
    isAdmin: 'Адміністратор',
    isExcon: 'EXCON',
    isPlanner: 'Планувальник',
    isHub: 'Вузол',
    isReadOnly: 'Лише читання',
    noUsers: 'Користувачів не знайдено',
    confirmDelete: 'Ви впевнені, що хочете видалити цього користувача?',
    resetPassword: 'Скинути пароль',
    generatePassword: 'Згенерувати пароль',
    searchUsers: 'Пошук користувачів...',
    userCreated: 'Користувача успішно створено',
    userUpdated: 'Користувача успішно оновлено',
    userDeleted: 'Користувача успішно видалено',
    selectNation: 'Оберіть країну',
    mustChangePassword: 'Необхідно змінити пароль при наступному вході',
    flagImage: 'Зображення прапора',
    exportUsers: 'Експорт користувачів',
    importUsers: 'Імпорт користувачів',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Засоби',
    createAsset: 'Створити засіб',
    editAsset: 'Редагувати засіб',
    deleteAsset: 'Видалити засіб',
    assetName: 'Назва засобу',
    assetType: 'Тип засобу',
    capacitySeated: 'Місткість (сидячі)',
    capacityLying: 'Місткість (лежачі)',
    capacityIntensive: 'Місткість (інтенсивна терапія)',
    owner: 'Власник',
    operator: 'Оператор',
    baseLocation: 'Базове розташування',
    range: 'Дальність',
    speed: 'Швидкість',
    noAssets: 'Засобів не знайдено',
    confirmDelete: 'Ви впевнені, що хочете видалити цей засіб?',
    searchAssets: 'Пошук засобів...',
    assetCreated: 'Засіб успішно створено',
    assetUpdated: 'Засіб успішно оновлено',
    assetDeleted: 'Засіб успішно видалено',
    exportAssets: 'Експорт засобів',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Вузли',
    startPoints: 'Початкові точки',
    createHub: 'Створити вузол',
    editHub: 'Редагувати вузол',
    deleteHub: 'Видалити вузол',
    hubName: 'Назва вузла',
    hubType: 'Тип вузла',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Вхідний вузол',
    airport: 'Аеропорт',
    seaport: 'Морський порт',
    railStation: 'Залізнична станція',
    roadPoint: 'Дорожній пункт',
    ucpmClassification: 'Класифікація UCPM',
    icaoCode: 'Код ICAO',
    iataCode: 'Код IATA',
    noHubs: 'Вузлів не знайдено',
    confirmDelete: 'Ви впевнені, що хочете видалити цей вузол?',
    searchHubs: 'Пошук вузлів...',
    nationAssignment: 'Призначення країн',
    assignNations: 'Призначити країни',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Лікувальні заклади',
    createFacility: 'Створити заклад',
    editFacility: 'Редагувати заклад',
    deleteFacility: 'Видалити заклад',
    facilityName: 'Назва закладу',
    facilityType: 'Тип закладу',
    hospitalName: 'Назва лікарні',
    bedCapacity: 'Ліжкова місткість',
    specialties: 'Спеціалізації',
    availableBeds: 'Доступні ліжка',
    totalBeds: 'Усього ліжок',
    contactPerson: 'Контактна особа',
    noFacilities: 'Лікувальних закладів не знайдено',
    confirmDelete: 'Ви впевнені, що хочете видалити цей заклад?',
    searchFacilities: 'Пошук закладів...',
    hubNationAssignment: 'Призначення країн до вузлів',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Розклади',
    createSchedule: 'Створити розклад',
    editSchedule: 'Редагувати розклад',
    deleteSchedule: 'Видалити розклад',
    scheduleName: 'Назва розкладу',
    scheduleType: 'Тип розкладу',
    recurring: 'Повторюваний',
    oneTime: 'Одноразовий',
    frequency: 'Частота',
    daily: 'Щоденно',
    weekly: 'Щотижнево',
    startDate: 'Дата початку',
    endDate: 'Дата завершення',
    departureTime: 'Час відправлення',
    arrivalTime: 'Час прибуття',
    stops: 'Зупинки',
    addStop: 'Додати зупинку',
    noSchedules: 'Розкладів не знайдено',
    bookings: 'Бронювання',
    timeline: 'Хронологія',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Сповіщення',
    markAllRead: 'Позначити всі прочитаними',
    markAsRead: 'Позначити як прочитане',
    markAsUnread: 'Позначити як непрочитане',
    noNotifications: 'Сповіщень немає',
    viewAll: 'Переглянути всі сповіщення',
    settings: 'Налаштування сповіщень',
    emailNotifications: 'Сповіщення електронною поштою',
    inAppNotifications: 'Сповіщення у застосунку',
    notifyOn: 'Сповіщувати мене про',
    requestCreated: 'Новий запит',
    requestPublished: 'Запит опубліковано',
    requestClosed: 'Запит закрито',
    requestCompleted: 'Запит завершено',
    commentAdded: 'Новий коментар',
    offerReceived: 'Отримано пропозицію',
    offerAccepted: 'Пропозицію прийнято',
    statusChanged: 'Статус змінено',
    selectionStarted: 'Відбір розпочато',
    missionCreated: 'Транспортування створено',
    missionStatusUpdated: 'Транспортування оновлено',
    transportPartnerNamed: 'Транспортний партнер',
    transportExtensionReceived: 'Продовження транспортування',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Налаштування',
    general: 'Загальні',
    system: 'Система',
    email: 'Електронна пошта',
    sync: 'Синхронізація',
    security: 'Безпека',
    appearance: 'Зовнішній вигляд',
    systemName: 'Назва системи',
    systemEmail: 'Системна електронна пошта',
    maintenanceMode: 'Режим обслуговування',
    readOnlyMode: 'Режим лише читання',
    emailEnabled: 'Електронна пошта увімкнена',
    smtpHost: 'Хост SMTP',
    smtpPort: 'Порт SMTP',
    smtpUser: 'Користувач SMTP',
    smtpPassword: 'Пароль SMTP',
    senderEmail: 'Електронна пошта відправника',
    senderName: 'Ім\'я відправника',
    testEmail: 'Надіслати тестовий лист',
    syncEnabled: 'Синхронізацію увімкнено',
    syncUrl: 'URL синхронізації',
    syncApiKey: 'Ключ API синхронізації',
    settingsSaved: 'Налаштування успішно збережено',
    helpdesk: 'Служба підтримки',
    helpdeskTitle: 'Назва служби підтримки',
    helpdeskEmail: 'Електронна пошта підтримки',
    helpdeskPhone: 'Телефон підтримки',
    helpdeskInfo: 'Інформація про підтримку',
    realLifeSupport: 'Реальна підтримка',
    trainingMode: 'Навчальний режим',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Журнал аудиту',
    action: 'Дія',
    user: 'Користувач',
    target: 'Ціль',
    details: 'Деталі',
    timestamp: 'Час',
    ipAddress: 'IP-адреса',
    noLogs: 'Записів аудиту не знайдено',
    searchLogs: 'Пошук записів...',
    filterByAction: 'Фільтрувати за дією',
    filterByUser: 'Фільтрувати за користувачем',
    exportLogs: 'Експорт записів',
    exportCsv: 'Експорт CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Керування навчанням',
    currentDay: 'Поточний день',
    exerciseDay: 'День навчання',
    nextDay: 'Наступний день',
    previousDay: 'Попередній день',
    resetExercise: 'Скинути навчання',
    startExercise: 'Розпочати навчання',
    endExercise: 'Завершити навчання',
    dayReset: 'Скидання дня',
    confirmReset: 'Ви впевнені, що хочете скинути день навчання? Це видалить усі дані за поточний день.',
    resetInProgress: 'Скидання в процесі...',
    maintenanceMode: 'Режим обслуговування',
    enableMaintenance: 'Увімкнути обслуговування',
    disableMaintenance: 'Вимкнути обслуговування',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Синхронізація даних',
    syncStatus: 'Статус синхронізації',
    lastSync: 'Остання синхронізація',
    pendingItems: 'Очікувані елементи',
    syncNow: 'Синхронізувати зараз',
    syncing: 'Синхронізація...',
    syncSuccess: 'Синхронізацію завершено успішно',
    syncFailed: 'Синхронізація не вдалася',
    outbox: 'Вихідні',
    inbox: 'Вхідні',
    configuration: 'Конфігурація',
    targetUrl: 'Цільова URL-адреса',
    apiKey: 'Ключ API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Карта',
    layers: 'Шари',
    requests: 'Запити',
    hubs: 'Вузли',
    facilities: 'Заклади',
    routes: 'Маршрути',
    showAll: 'Показати все',
    hideAll: 'Приховати все',
    zoomIn: 'Збільшити',
    zoomOut: 'Зменшити',
    resetView: 'Скинути вигляд',
    satellite: 'Супутник',
    terrain: 'Рельєф',
    offline: 'Офлайн',
    online: 'Онлайн',
    tilesOffline: 'Фрагменти карти обслуговуються локально',
    tilesOnline: 'Фрагменти карти завантажуються з онлайн-серверів',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Статистика',
    overview: 'Огляд',
    requestsByStatus: 'Запити за статусом',
    requestsByCategory: 'Запити за категорією',
    requestsByNation: 'Запити за країною',
    offersByStatus: 'Пропозиції за статусом',
    patientsByCondition: 'Пацієнти за станом',
    transportsByStatus: 'Транспортування за статусом',
    timeline: 'Хронологія',
    totalRequests: 'Усього запитів',
    totalOffers: 'Усього пропозицій',
    totalPatients: 'Усього пацієнтів',
    totalTransports: 'Усього транспортувань',
    averageResponseTime: 'Середній час відповіді',
    completionRate: 'Рівень завершення',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Статистика навчань',
    overview: 'Огляд',
    byCategory: 'За категорією',
    byNation: 'За країною',
    byDay: 'За днем',
    totalPatientsMoved: 'Усього переміщених пацієнтів',
    totalRequestsProcessed: 'Усього оброблених запитів',
    averageProcessingTime: 'Середній час обробки',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Діаграма потоків',
    sankey: 'Санкей',
    nodeGraph: 'Графік вузлів',
    refresh: 'Оновити',
    noData: 'Дані потоків відсутні',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Про систему',
    version: 'Версія',
    systemInfo: 'Інформація про систему',
    buildDate: 'Дата збірки',
    environment: 'Середовище',
    description: 'ARCOS — Розширена система запитів та комунікації',
    subtitle: 'Допомога постраждалим та медичні операції',
    whatIsArcos: 'Що таке ARCOS? – Пояснення для учасників навчань',
    arcosDesc1: 'ARCOS — це цифровий інструмент, що використовується в цих навчаннях для підтримки та структурування міжнародної комунікації, запитів та координаційних процесів між учасниками.',
    arcosDesc2: 'ARCOS забезпечує спрощене, орієнтоване на навчання представлення основних принципів цих систем.',
    arcosUsedFor: 'Під час навчань ARCOS використовується для представлення типових процесів:',
    arcosUsedForItem1: 'подання та управління запитами на допомогу,',
    arcosUsedForItem2: 'координація та відповідь на пропозиції підтримки від інших націй,',
    arcosUsedForItem3: 'відстеження статусу та прогресу запитів,',
    arcosUsedForItem4: 'та представлення спрощених транспортних або евакуаційних робочих процесів.',
    arcosDesc3: 'Робочі процеси в ARCOS навмисно спрощені та адаптовані до конкретних навчальних цілей.',
    arcosDesc4: 'Мета ARCOS — не симулювати досконалу або повну реальну систему.',
    arcosDesc5: 'Якщо деякі елементи відрізняються від реальних процедур, які ви знаєте, це очікувано.',
    facilitatedBy: 'За підтримки MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) — спільна ініціатива:',
    dhcAuthor1: 'Sven Giegerich — Збройні сили Німеччини',
    dhcAuthor2: 'Mohamad Haji — Оборона Бельгії',
    dhcConviction: 'Народжена з переконання, що інновації процвітають там, де пристрасть зустрічає прагматизм.',
    dhcInspired: 'Натхнені MMCC-E, ми створили прості, але ефективні рішення.',
    dhcLove: 'Ми робимо це, бо любимо свою роботу і віримо, що цифрові ідеї можуть трансформувати співпрацю у військовій медицині.',
    dhcOpen: 'DHC — відкрита платформа: вільна від ієрархій, відкрита для ідей, рушійна силою цікавості.',
    dhcClosing: 'Digital Health Corner – де цікавість зустрічає співпрацю.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Документація',
    gettingStarted: 'Початок роботи',
    userGuide: 'Посібник користувача',
    faq: 'Часті запитання',
    troubleshooting: 'Усунення несправностей',
    apiReference: 'Довідник API',
    downloadTemplate: 'Завантажити шаблон',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Імпорт пацієнтів',
    uploadFile: 'Вивантажити файл',
    selectFile: 'Обрати файл',
    preview: 'Попередній перегляд',
    importNow: 'Імпортувати зараз',
    importing: 'Імпорт...',
    importSuccess: '{{count}} пацієнтів успішно імпортовано',
    importFailed: 'Імпорт не вдався',
    downloadTemplate: 'Завантажити шаблон',
    dragDrop: 'Перетягніть файл сюди або натисніть, щоб обрати',
    supportedFormats: 'Підтримувані формати: XLSX, XLS, CSV',
    rowsFound: 'Знайдено {{count}} рядків',
    validRows: '{{count}} дійсних рядків',
    invalidRows: '{{count}} недійсних рядків',
    duplicateRows: '{{count}} дублікатів рядків',
    previewData: 'Попередній перегляд даних',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Планування транспортування',
    planRoute: 'Спланувати маршрут',
    routeBuilder: 'Конструктор маршрутів',
    addWaypoint: 'Додати проміжну точку',
    removeWaypoint: 'Вилучити проміжну точку',
    estimatedDuration: 'Орієнтовна тривалість',
    distance: 'Відстань',
    selectVehicle: 'Обрати транспортний засіб',
  },

  transportBooking: {
    title: 'Бронювання транспорту',
    bookTransport: 'Забронювати транспорт',
    availableSlots: 'Доступні місця',
    bookingConfirmed: 'Бронювання підтверджено',
    cancelBooking: 'Скасувати бронювання',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Планування потужностей',
    totalCapacity: 'Загальна місткість',
    usedCapacity: 'Використана місткість',
    availableCapacity: 'Доступна місткість',
    utilizationRate: 'Рівень використання',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Шаблони засобів',
    dayTemplates: 'Шаблони днів',
    createTemplate: 'Створити шаблон',
    editTemplate: 'Редагувати шаблон',
    deleteTemplate: 'Видалити шаблон',
    templateName: 'Назва шаблону',
    applyTemplate: 'Застосувати шаблон',
    noTemplates: 'Шаблонів не знайдено',
    confirmDelete: 'Ви впевнені, що хочете видалити цей шаблон?',
    confirmApply: 'Ви впевнені, що хочете застосувати цей шаблон? Це перезапише наявні дані.',
    exportTemplates: 'Експорт шаблонів',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Стрічка оголошень',
    createAnnouncement: 'Створити оголошення',
    editAnnouncement: 'Редагувати оголошення',
    deleteAnnouncement: 'Видалити оголошення',
    message: 'Повідомлення',
    startTime: 'Час початку',
    endTime: 'Час закінчення',
    active: 'Активне',
    noAnnouncements: 'Оголошень немає',
    confirmDelete: 'Ви впевнені, що хочете видалити це оголошення?',
  },

  // ============================================================
  // COMPONENTS — Рядки багаторазових компонентів
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Пошук...',
      noResults: 'Результатів не знайдено',
      showing: 'Показано {{from}} до {{to}} з {{total}}',
      rowsPerPage: 'Рядків на сторінку',
      previousPage: 'Попередня сторінка',
      nextPage: 'Наступна сторінка',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Підтвердити',
      cancel: 'Скасувати',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Незбережені зміни',
      message: 'У вас є незбережені зміни. Ви впевнені, що хочете покинути цю сторінку?',
      stay: 'Залишитися на сторінці',
      leave: 'Покинути сторінку',
    },
    // EmptyState
    emptyState: {
      noData: 'Дані відсутні',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Щось пішло не так',
      message: 'Сталася неочікувана помилка. Будь ласка, спробуйте оновити сторінку.',
      retry: 'Повторити',
    },
    // ExportButton
    exportButton: {
      export: 'Експорт',
      exporting: 'Експорт...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Друк',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Чернетка',
      review: 'Розгляд',
      published: 'Опубліковано',
      selection: 'Відбір',
      inTransit: 'У дорозі',
      completed: 'Завершено',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Онлайн-екземпляр',
      message: 'Режим лише читання. Дані синхронізуються з основного сервера.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Ви переглядаєте як',
      loggedInAs: 'увійшли як {{nation}}',
      returnTo: 'Повернутися до {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Пошук сторінок, запитів, транспортувань...',
      searching: 'Пошук...',
      noResults: 'Немає результатів для "{{query}}"',
      navigate: 'Перейти',
      select: 'Обрати',
      close: 'Закрити',
      pages: {
        dashboard: 'Головна панель',
        requests: 'Запити',
        transports: 'Транспортування',
        map: 'Карта',
        myPatients: 'Мої пацієнти',
        flowDiagram: 'Діаграма потоків',
        statistics: 'Статистика',
        assets: 'Засоби',
        startPoints: 'Початкові точки / Вузли',
        treatmentFacilities: 'Лікувальні заклади',
        users: 'Користувачі',
        settings: 'Налаштування',
        auditLogs: 'Журнал аудиту',
        exerciseControl: 'Керування навчанням',
        dataSync: 'Синхронізація даних',
        patientImport: 'Імпорт пацієнтів',
        notifications: 'Сповіщення',
        documentation: 'Документація',
      },
      actions: {
        importPatientsJson: 'Імпортувати Пацієнтів (JSON)',
        importPatientsExcel: 'Імпортувати Пацієнтів (Excel)',
        importUsers: 'Імпортувати Користувачів (Excel)',
        importAssetTemplates: 'Імпортувати Шаблони активів (Excel)',
        importDayTemplates: 'Імпортувати Записи денного шаблону (Excel)',
        exportRequests: 'Експортувати Запитів (Excel)',
        exportPatients: 'Експортувати Пацієнтів (Excel)',
        exportUsers: 'Експортувати Користувачів (Excel)',
        exportCredentials: 'Експортувати Облікові дані (PDF)',
        exportAuditExcel: 'Експортувати Журнал аудиту (Excel)',
        exportAuditPdf: 'Експортувати Журнал аудиту (PDF)',
        pagePatientImport: 'Сторінка імпорту пацієнтів',
        pageRequestDetail: 'Сторінка деталей запиту',
        pageUsers: 'Сторінка керування користувачами',
        pageAssetTemplates: 'Сторінка шаблонів активів',
        pageDayTemplates: 'Сторінка денних шаблонів',
        pageRequests: 'Сторінка списку запитів',
        pageAuditLogs: 'Сторінка журналу аудиту',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Сеанс закінчується',
      message: 'Ваш сеанс закінчиться через <strong>{{time}}</strong>. Будь ласка, збережіть роботу та увійдіть знову, щоб продовжити.',
      dismiss: 'Закрити',
      logoutNow: 'Вийти зараз',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Оберіть 4 часові пояси',
      configure: 'Налаштувати часові пояси',
      reset: 'Скинути',
      apply: 'Застосувати',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Обрати місце',
      latitude: 'Широта',
      longitude: 'Довгота',
      clickToSelect: 'Натисніть на карту, щоб обрати місце',
    },
    // Modal
    modal: {
      close: 'Закрити',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Головна',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Обслуговування системи',
    message: 'Система скидається для наступного дня навчання. Будь ласка, зачекайте, поки процес завершиться.',
    autoRefresh: 'Ця сторінка автоматично оновиться, коли система знову стане доступною.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Щонайменше 10 символів',
    uppercase: '1 велика літера',
    lowercase: '1 мала літера',
    digit: '1 цифра',
    special: '1 спеціальний символ',
  },
};

export default uk;
